import PortfolioPhoto1 from '../../assets/portfolio-photo-1.webp';
import PortfolioPhoto2 from '../../assets/portfolio-photo-2.webp';
import PortfolioPhoto3 from '../../assets/portfolio-photo-3.webp';
import PortfolioPhoto4 from '../../assets/portfolio-photo-4.webp';
import PortfolioPhoto5 from '../../assets/portfolio-photo-5.webp';
import PortfolioPhoto6 from '../../assets/portfolio-photo-6.webp';
import PortfolioPhoto7 from '../../assets/portfolio-photo-7.webp';
import PortfolioPhoto8 from '../../assets/portfolio-photo-8.webp';


const portfolioData = [
    {
        id: 1,
        text: "Ned & Fizzah",
        video: "https://vimeo.com/1134838062",
        photo: PortfolioPhoto1
    },

    {
        id: 2,
        text: "Dario & Kseniya",
        video: "https://vimeo.com/1134838909",
        photo: PortfolioPhoto2
    },

    {
        id: 3,
        text: "Elie & Riwa",
        video: "https://vimeo.com/1119406813?fl=pl&fe=sh",
        photo: PortfolioPhoto8
    },

    {
        id: 4,
        text: "Paolo & Angela",
        video: "https://vimeo.com/1106781297",
        photo: PortfolioPhoto7
    },

    {
        id: 5,
        text: "Dimitri & Valery",
        video: "https://vimeo.com/950782164",
        photo: PortfolioPhoto6
    },

    // {
    //     id: 4,
    //     text: "Akos & Klara",
    //     video: "https://vimeo.com/757290679/fa8c100dc8?share=copy",
    //     photo: PortfolioPhoto1
    // },

    {
        id: 6,
        text: "Rosh & Zena",
        video: "https://vimeo.com/879873119",
        photo: PortfolioPhoto5
    },

    // {
    //     id: 6,
    //     text: "Auston & Lyanne",
    //     video: "https://vimeo.com/878378255?share=copy",
    //     photo: PortfolioPhoto2
    // },

    {
        id: 7,
        text: "Mykhail & Ilona",
        video: "https://vimeo.com/878386305?share=copy",
        photo: PortfolioPhoto3
    },

    {
        id: 8,
        text: "Marek & Katya",
        video: "https://vimeo.com/889826388",
        photo: PortfolioPhoto4
    },

    
];

export default portfolioData;